import { Injectable } from '@angular/core';

import { DataService } from '../services/data.service';
import { DialogService } from 'primeng/dynamicdialog';
import { GuardConfirmModalComponent } from 'src/app/shared/components/modals/guard-confirm-modal/guard-confirm-modal.component';
import { ApiService } from '../services/api.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@devinforius/super-compos-17';

@Injectable({
  providedIn: 'root',
})
export class ConfirmDeactivateGuard  {
  constructor(public dialogService: DialogService, public dataService: DataService, public api: ApiService, public translate: TranslateService, private toastr: ToastrService) { }

  canDeactivate(component: any): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.dataService.checkIfUnsavedChanges === true) {
        const ref = this.dialogService.open(GuardConfirmModalComponent, {
          header: 'Confirmation',
          styleClass: 'super-compos-modal-content confirm-inforius',
          dismissableMask: false,
          width: '30em',
          data: {
            message: 'Etes-vous sûr de vouloir quitter sans sauver vos changements ?',
          },
        });
        ref.onClose.subscribe((value) => {
          if (value) {
            if (value === true) {
              this.dataService.checkIfUnsavedChanges = false;
              this.api.ReleaseWriteLock(component.pointId).subscribe((res: any) => {
                if (res) {
                  this.toastr.info(this.translate.translate('info.pointUnlocked'));
                }
              }, (error) => {
                this.toastr.error(this.translate.translate('errorOccurred'));
              });
              resolve(true);
            } else {
              resolve(false);
            }
          }
        });
      } else {
        resolve(true);
      }
    });
  }
}
